import { HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    LowFunds = '/api/PostLoginController/LowFundsAlreadyDisplayed/',
    GetPostLoginActions = '/api/PostLoginController/GetPostLoginActions/',
    PerformPostLoginRequired = '/api/PostLoginController/PerformPostLoginRequired/',
    GetLoginToastData = '/api/PostLoginController/GetLoginToastData/',
    CheckIfTempUser = '/api/PostLoginController/CheckIfTempUser/',
    UploadDocumentsAlreadyDisplayed = '/api/PostLoginController/UploadDocumentsAlreadyDisplayed/',
}

export default class PostLoginApi {
    public static LowFundsAlreadyDisplayed = async () =>
        ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.LowFunds,
            method: HTTPVerb.GET,
        });

    public static GetActions = async () =>
        ApiManager.getAPIInstance().request({
            url: APIConstants.GetPostLoginActions,
            method: HTTPVerb.GET,
        });

    public static IsExecutionRequired = async () =>
        ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.PerformPostLoginRequired,
            method: HTTPVerb.POST,
        });

    public static GetLoginToastData = async () =>
        ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.GetLoginToastData,
            method: HTTPVerb.GET,
        });

    public static CheckIfTempUser = async () =>
        ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.CheckIfTempUser,
            method: HTTPVerb.GET,
        });

    public static UploadDocumentsAlreadyDisplayed = async () =>
        ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.UploadDocumentsAlreadyDisplayed,
            method: HTTPVerb.GET,
        });
}
